var _circle, _path, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOzuspoj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 31.08,
    cy: 27,
    r: 4.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M39.17 37.63v-.81c0-2.35-1.91-4.26-4.26-4.26h-7.66c-2.35 0-4.26 1.91-4.26 4.26v.81"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 27.46,
    cy: 37.02,
    r: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M13.28 17.91l7.77-7.77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.22 17.11V8.43c0-2.39-1.94-4.32-4.32-4.32H7.67c-2.39 0-4.32 1.94-4.32 4.32v11.08c0 2.39 1.94 4.32 4.32 4.32h3.9M19.68 23.84h2.02M19.68 23.84v5.95l-8.1-5.95"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M13.46 12.44c-1.13 0-2.06-.92-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.92 2.06-2.06 2.06zM21.12 19.62c-1.13 0-2.06-.92-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.92 2.06-2.06 2.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzuspoj);
export default __webpack_public_path__ + "static/media/OZUSPOJ.19faec1680acbab9277f134dbdf4e595.svg";
export { ForwardRef as ReactComponent };